/** Visible copy migrated from Vue templates; translations are generated through Seede. */
export const visibleCopyEn = {
  componentsAiInputBox: {
    alt1: 'Pinterest',
    alt2: 'Behance',
    alt3: 'Dribbble',
    alt4: 'instagram',
    alt5: 'thread',
    alt6: 'midjourney',
    alt7: 'x',
    text1: 'Upload',
    text2: 'History',
    alt8: 'Design reference',
  },
  componentsAssetItem: {
    text1: 'PDF',
    text2: 'TXT',
    text3: 'AI',
  },
  componentsEditCanvas: {
    alt1: 'Veeso AI',
    text1: 'Share',
    text2: 'Copy link',
    text3: 'Share to',
    text4: 'Welcome to',
    text5: 'Veeso AI',
    text6: "You're the",
    text7: 'ROKI',
    text8: 'WANG',
    text9: 'Anyone can',
    text10: 'design with',
    text11: 'Veeso AI',
    text12: "We're good",
    text13: 'at designing',
    text14: 'for scenes',
    text15: 'Long form',
    text16: 'posters',
    text17: 'Sales emails',
    text18: 'Hiring poster',
    text19: 'Social Post',
    text20: 'Invite Cards',
    text21: 'ON THE',
    text22: 'LIST.',
    alt2: 'Design',
    text23: 'Veeso AI',
    text24: 'Frame 1',
    title3: 'Select',
    title4: 'Deep Select',
    title5: 'Hand',
    text25: 'Now just',
    text26: 'Sign in',
    text27: 'or',
    text28: 'Sign up',
    text29: 'to design better, fast.',
    text30: 'I will design the poster in',
    placeholder6: 'Want to try? Type something...',
    text31: 'Generate',
  },
  componentsHeader: {
    alt1: 'Veeso Logo',
    ariaLabel2: 'Toggle menu',
    alt3: 'Veeso Logo',
    ariaLabel4: 'Close menu',
  },
  componentsHeroCards: {
    text1: 'Copy Prompt',
    text2: 'Copy Prompt',
    text3: 'Copy Prompt',
    text4: 'Copy Prompt',
    text5: 'Copy Prompt',
    text6: 'Copy Prompt',
    text7: 'Copy Prompt',
    text8: 'Copy Prompt',
    text9: 'Copy Prompt',
  },
  componentsHeroCenter: {
    text1: 'Design',
    text2: 'with Veeso AI',
    text3:
      'Turn your ideas into stunning polished designs in minutes for any content, any language, any format.',
    placeholder1: "What's in your mind now",
    title2: 'Add attachment',
    text4: 'Select Model',
    text5: 'Select Style',
    title3: 'More options',
    text6: 'More Options',
    text7: 'Generate',
  },
  componentsHeroNav: {
    alt1: 'Veeso AI',
    alt2: 'Veeso AI',
    text1: 'Use Case',
    text2: 'Community',
    text3: 'Pricing',
    text4: 'Log In',
    text5: 'Start Free',
    text6: 'Use Case',
    text7: 'Community',
    text8: 'Pricing',
    text9: 'Log In',
  },
  componentsMockCanvas: {
    alt1: 'Veeso AI',
  },
  componentsMockChatComposer: {
    ariaLabel1: 'Remove attachment',
    ariaLabel2: 'Add file',
    ariaLabel3: 'Generating',
    ariaLabel4: 'Send',
  },
  componentsAiToolsAiToolsSeoContent: {
    text1: ', and',
  },
  componentsAssetImagePreview: {
    text1: 'px',
    text2: 'KB',
  },
  componentsAuthBackground: {
    alt1: 'Design example',
  },
  componentsAuthGallery: {
    alt1: 'Design example',
  },
  componentsAuthUserMenu: {
    text1: 'Upgrade',
  },
  componentsAuthUserProfile: {
    alt1: 'Avatar preview',
    text1: 'Change Avatar',
    text2: 'Saving...',
  },
  componentsCreateAddMaterialAssetPicker: {
    text1: 'View All',
    text2: 'Showing all materials',
  },
  componentsCreateImagePreview: {
    alt1: 'Reference image',
  },
  componentsCreateMagicTemplateSelector: {
    text1: 'Pick a magic template',
    text2: 'Discover',
    text3: 'My templates',
    text4: 'History',
  },
  componentsCreateProductItem: {
    text1: 'NEW',
  },
  componentsCreateSkillCard: {
    text1: 'Use as template',
    text2: 'Delete',
  },
  componentsCreateSkillSelector: {
    text1: 'Community',
    text2: 'My templates',
  },
  componentsCreateAttachAttachPreview: {
    text1: 'Done',
  },
  componentsCreateEntryDocumentEntryCard: {
    text1: 'A',
  },
  componentsFeaturesFeaturesFaq: {
    text1: ', and',
  },
  componentsFeaturesFeaturesHeroNext: {
    text1: 'Turn',
    text2: 'document',
    text3: 'into',
    text4: 'production-ready designs',
    text5: 'Works for social posts, decks, posters, LinkedIn/Meta ads, and EDM campaigns.',
    text6: 'Start for Free',
    text7: 'Get 300 free credits',
    text8: 'No credit card required',
    text9: 'Veeso Workspace',
    text10: 'Drop your content',
    text11: 'Raw copy, notes, or any document.',
    text12: 'Exposição: O Sentido da Viagem',
    text13: 'Desenhos de Julio Resende',
    text14: '13 Janeiro - 25 Fevereiro',
    text15: 'Casa Municipal da Cultura, Estarreja',
    text16: 'Veeso AI',
    text17: 'Get polished designs',
    text18: 'Fully editable, perfectly layouted.',
    text19: 'Fully editable',
    text20: 'Print-ready PDF & PNG',
    alt1: 'Stunning editable design',
    text21: 'A Text',
    text22: 'Image',
  },
  componentsFeaturesCardsFeatureCardDeliver: {
    text1: 'Export',
  },
  componentsFeaturesCardsFeatureCardLatestModels: {
    text1: 'Latest AI Models.',
    text2: 'Always cutting-edge, auto-updated.',
    text3: 'Gemini 3 Pro',
    text4: 'Google',
    text5: 'Nano Banana',
    text6: 'Google',
    text7: 'GPT-5',
    text8: 'OpenAI',
    text9: 'GPT-4.1',
    text10: 'OpenAI',
    text11: 'Claude 4.5',
    text12: 'Anthropic',
    text13: 'Qwen-Image',
    text14: 'Alibaba Cloud',
    text15: 'Kimi',
    text16: 'Moonshot',
    text17: 'Deepseek',
    text18: 'Deepseek',
    text19: 'GLM',
    text20: 'ZHIPU',
    text21: 'Mini Max M2',
    text22: 'MiniMax',
    text23: 'Qwen-VL',
    text24: 'Alibaba Cloud',
    text25: 'xAI',
    text26: 'X',
  },
  componentsFeaturesCardsFeatureCardMultiContent: {
    text1: 'Multi-Content Layout.',
    text2: 'Auto page arrangement for long-form content.',
    title1: 'Replay animation',
    text3: 'PDF',
    alt2: 'Multi-page design layout',
    alt3: 'Multi-page design layout',
    text4: 'PDF',
    text5: 'document.pdf',
    text6: 'Paste content or upload file...',
    text7: 'Designing',
    text8: 'Design',
  },
  componentsFeaturesCardsFeatureCardRemoveBg: {
    alt1: 'Christmas background',
    alt2: 'Original image with background',
    alt3: 'Image with background removed',
  },
  componentsFeaturesCardsFeatureCardSpeed: {
    text1: 'Lightning Fast.',
    text2: 'AI generates stunning designs in minutes.',
    title1: 'Replay animation',
  },
  componentsFeaturesCardsFeatureCardTextEdit: {
    text1: 'Edit Text Directly.',
    text2: 'Click, type, instant changes.',
  },
  componentsFeaturesCardsFeatureCardUpscale: {
    alt1: 'Low resolution preview',
    alt2: 'HD Upscale preview',
  },
  componentsFeaturesV3BlackPressPoster: {
    ariaLabel1: 'Black Press Poster',
    text1: 'DOCUMENT NO. 07.12',
    text2: 'FILE: PUBLIC RECORDS',
    text3: 'ARCHIVE REF: 233-NY',
    text4: 'FRI',
    text5: 'IN THE SOUND ROOM',
    text6: 'JOEL MULL',
    text7: '+ UMFANG',
    text8: 'IN THE ATRIUM',
    text9: 'TAMMY LAKKIS',
    text10: "+ FOR FUTURE'S SAKE",
    text11: 'AT PUBLIC RECORDS',
    text12: '233 BUTLER ST, BROOKLYN, NY',
    text13: 'DOORS',
    text14: 'AT 11PM',
  },
  componentsFeaturesV3HeroV3: {
    text1: 'Preview unavailable',
  },
  componentsFeaturesV3LayeredFileV3: {
    alt1: 'Seede',
    ariaLabel2: 'Acid Brutalism Event Poster',
    alt3: 'Abstract industrial texture',
    text1: 'IN',
    text2: 'THE',
    text3: 'SOUND',
    text4: 'ROOM',
    text5: "FOR FUTURE'S SAKE",
    text6: 'IN',
    text7: 'THE',
    text8: 'ATRIUM',
    text9: 'AT PUBLIC RECORDS',
    text10: 'DOORS AT 11PM',
    text11: 'FRI 7.12',
    text12: 'BROOKLYN',
    text13: 'BUTLER',
    text14: 'ST,',
    text15: 'NY',
    text16: 'PRESETS',
    text17: 'PRESETS',
    text18: '2x',
    text19: '· 2160×3840px',
  },
  componentsFeaturesV3RetroPixelPoster: {
    ariaLabel1: 'Retro Pixel Signal Poster',
    text1: '[ SYS.DATE ]',
    text2: 'FRI 7.12',
    text3: '[ LOCATION ]',
    text4: 'PUBLIC RECORDS',
    text5: '> RUN_PROGRAM: MAIN_STAGE',
    text6: 'JOEL MULL',
    text7: '+ UMFANG',
    text8: 'IN THE',
    text9: 'SOUND ROOM',
    text10: '> RUN_PROGRAM: SECONDARY',
    text11: 'SAKE',
    text12: 'SAKE',
    text13: 'SAKE',
    text14: 'IN THE',
    text15: 'ATRIUM',
    text16: '233 BUTLER ST, BROOKLYN, NY',
    text17: 'DOORS AT 11PM',
  },
  componentsIconsSFStar: {
    ariaLabel1: 'star',
  },
  componentsLearnLearnDocPage: {
    ariaLabel1: 'Use-case carousel',
    ariaLabel2: 'Generate, edit, and export demo',
  },
  componentsLearnLearnDocsSearch: {
    text1: 'K',
  },
  componentsLearnLearnDocsShell: {
    ariaLabel1: 'Learn navigation',
  },
  componentsLearnLearnEditorAIPresetsTable: {
    text1: 'Icon',
    text2: 'Preset',
    text3: 'Effect',
  },
  componentsLearnLearnEditorImageToolbarTable: {
    text1: 'Control',
    text2: 'Name',
    text3: 'What it does',
  },
  componentsLearnLearnEditorTextAdvancedIntro: {
    text1: 'Beyond the basic controls, click the far-right',
    text2:
      'button to open the **Design panel** on the left with **Color**, **Decoration**, and **Font** tabs.',
  },
  componentsLearnLearnEditorTextToolbarTable: {
    text1: 'Control',
    text2: 'Name',
    text3: 'What it does',
    text4: 'Inter',
  },
  componentsMockCanvasSlidesIgSlide04Comfort: {
    text1:
      'By designing spaces with thoughtful layouts and green surroundings, we cultivate a healthier and more balanced lifestyle.',
    text2:
      'Natural light, open spaces, and efficient materials reduce stress and energy use. Each build is planned to bring comfort and sustainability.',
  },
  componentsMockCanvasSlidesIgSlide07Reviews: {
    alt1: 'star',
  },
  componentsMockCanvasSlidesIgSlide08SalesGrowth: {
    text1: 'Demand for modern housing continues to increase.',
    text2:
      'of new inquiries are for smart, minimalist homes located near city centers — showing a 20% jump compared to last quarter.',
  },
  componentsMockCanvasSlidesSvSlide01Poster: {
    alt1: 'Featured Artist',
    text1: 'SUPPORTED BY',
  },
  componentsMockCanvasSlidesSvSlide03Ad: {
    text1:
      'TICKETS ON SALE NOW • VIP PASSES AVAILABLE • BOOK YOUR CABANA • MAIN STAGE ACCESS • TICKETS ON SALE NOW • VIP PASSES AVAILABLE',
  },
  componentsMockCanvasSlidesSvSlide04Invitation: {
    text1:
      'Join us at Sunset Beach for three days of incredible music, ocean breezes, and unforgettable moments. You are exclusively invited.',
    alt1: 'Featured Artist',
    text2: 'SCAN TO',
    text3: 'RSVP',
    text4: 'CODE: SV25-VIP',
    text5: 'ORGANIZED BY',
    text6: 'VIBES.PROD',
    text7: 'SPONSOR',
    text8: 'STAR BRAND',
    text9: 'MEDIA',
    text10: 'THE MUSIC TIMES',
  },
  componentsMockCanvasSlidesWgpSlide02WhatMoved: {
    text1: 'Revenue $196,980',
    text2: '+5.1% WoW',
    text3: 'Conversion Rate 1.50%',
    text4: '-0.06pp WoW',
    text5: 'Returning Customer Rate 30.1%',
    text6: '+1.7pp WoW',
    text7: 'Blended CAC $26.80',
    text8: '+11.2% WoW',
  },
  componentsPricingPricingFaq: {
    text1: ', and',
  },
  componentsUiBreadcrumbBreadcrumbEllipsis: {
    text1: 'More',
  },
  componentsUiBreadcrumbBreadcrumb: {
    ariaLabel1: 'breadcrumb',
  },
  componentsUiCarouselCarouselNext: {
    text1: 'Next Slide',
  },
  componentsUiCarouselCarouselPrevious: {
    text1: 'Previous Slide',
  },
  componentsUiDialogDialogScrollContent: {
    text1: 'Close',
  },
  componentsWorkspaceSkillsSkillCard: {
    text1: 'Edit',
    text2: 'Copy Skill',
    text3: 'Delete',
  },
  componentsWorkspaceSkillsSkillCardFlow: {
    text1: 'Add',
  },
  componentsWorkspaceSkillsSkillForm: {
    text1: 'Resolve Size',
  },
  componentsWorkspaceSkillsSkillImageManager: {
    text1: 'As',
    text2: 'Select Reference Points',
    text3: 'Add',
  },
  componentsWorkspaceSkillsSkillTags: {
    text1: 'Add Tag',
  },
  pagesAiDesignToolsSlug: {
    text1: 'Get Started',
    text2: 'Why choose Veeso for your',
    text3: 'Start Creating Now',
    text4: 'No credit card required • Free to start • No design skills required',
    text5: 'Discover more creative design scenarios powered by Veeso AI.',
  },
  pagesBlogSlug: {
    text1: 'Join Discord',
  },
  pagesForgot: {
    alt1: 'Veeso AI',
  },
  pagesLogin: {
    alt1: 'Veeso AI',
  },
  pagesSignup: {
    alt1: 'Veeso AI',
  },
  pagesWorkspace: {
    alt1: 'Veeso Logo',
    alt2: 'Veeso Logo',
  },
  pagesWorkspaceCreate: {
    text1: 'What do you want to design,',
  },
} as const;
